export default "__VITE_ASSET__46569099__"